import React from "react";
import { Card } from "reactstrap";
import { useTheme } from "../../context/ThemeContext";

interface ThemeCardProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const ThemeCard: React.FC<ThemeCardProps> = ({
  children,
  className = "",
  style = {}
}) => {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  return (
    <Card
      className={`shadow-sm border-0 rounded-4 ${className}`}
      style={{
        backgroundColor: isDark ? "#1e1e1e" : "#ffffff",
        color: isDark ? "#e9ecef" : "inherit",
        ...style
      }}
    >
      {children}
    </Card>
  );
};

export default ThemeCard;